import axios from 'axios'
import * as CryptoJS from 'crypto-js'
import { BACKEND_URL, SERVICE_URL, CURRENT_TIME_URL } from '.'
import { useToast } from '../hooks/usetoast'

const environment = {
    abfmeyohryhgbvlrgp: SERVICE_URL,
    apiUrl: BACKEND_URL,
    currentTimeUrl: CURRENT_TIME_URL
}

const DataService = () => {
    const REST_API_SERVER = environment.apiUrl
    const REST_API_TIME = environment.currentTimeUrl
    const toast = useToast()
    
    const getGen = (url, getTime) => {
        url = `${url}`
        const date = getTime
        const ex_date = Math.round(date / 1000) + 5
        const payload = {
            exp: ex_date,
            isHuman: true
        }

        const token = signToken(payload, url)
        const encrtpted_token = CryptoJS.AES.encrypt(
            token,
            environment.abfmeyohryhgbvlrgp
        ).toString()

        return { token: encrtpted_token }
    }


    const base64url = source => {
        let encodedSource = CryptoJS.enc.Base64.stringify(source);
        if (encodedSource.endsWith('=')) {
            let paddingIndex = encodedSource.length;
            while (paddingIndex > 0 && encodedSource[paddingIndex - 1] === '=') {
                paddingIndex--;
            }
            encodedSource = encodedSource.slice(0, paddingIndex);
        }
        encodedSource = encodedSource.replace(/\+/g, '-')
            .replace(/\//g, '_');
        return encodedSource;
    };


    const signToken = (payload, key) => {
        const secret = key
        const token = encodeToken(payload)
        let signature = CryptoJS.HmacSHA256(token, secret)
        signature = base64url(signature)
        const signedToken = `${token}.${signature}`
        return signedToken
    }


    const encodeToken = payload => {
        const header = {
            alg: 'HS256',
            typ: 'JWT'
        }
        const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header))
        const encodedHeader = base64url(stringifiedHeader)
        const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload))
        const encodedData = base64url(stringifiedData)
        const token = `${encodedHeader}.${encodedData}`
        return token
    }


    const doAnotherthing = async () => {
        // ใช้เวลาปัจจุบันจากเครื่องคอมพิวเตอร์แทนการยิง API ป้องกัน ERR_EMPTY_RESPONSE
        return { data: Date.now() };
    }

    const getRequest = async url => {
        const token = sessionStorage.getItem('apayroucarayxczijiuhxvkdsp')
        try {
            const datetime = await doAnotherthing()
            const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
            const headers = {
                'cache-control': 'no-cache',
                'content-type': 'application/json', // 👈 เติมบรรทัดนี้เข้ามาครับ
                Authorization: "Bearer " + token,
                abfmeyohryhgbvlrgp: tokenHandling.token,
                BvFGbVtImTvIuDR: "MnBrVCrXEChDaWgU"
            }
            const response = await axios.get(`${REST_API_SERVER}${url}`, { headers })
            if (response?.data?.status === 419) {
                toast.error(response?.data?.message)
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            } else if (response?.data?.statusCode == 419) {
                toast.error("Session expired!.")
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            }
            return response
        } catch (error) {
            return error?.response?.data
        }
    }

    const postRequest = async (url, requestData) => {
        const token = sessionStorage.getItem('apayroucarayxczijiuhxvkdsp')
        try {
            const datetime = await doAnotherthing()
            const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
            const headers = {
                'cache-control': 'no-cache',
                Authorization: "Bearer " + token,
                abfmeyohryhgbvlrgp: tokenHandling.token,
                BvFGbVtImTvIuDR: "MnBrVCrXEChDaWgU"
            }

            const response = await axios.post(`${REST_API_SERVER}${url}`, requestData, { headers })
            if (response?.data?.status === 419) {
                toast.error(response?.data?.message)
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            } else if (response?.data?.statusCode === 419) {
                toast.error("Session expired!.")
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            }
            return response
        } catch (error) {
            console.log("FULL ERROR OBJECT:", error);
            console.log("RESPONSE ERROR DATA:", error?.response?.data);
            const errorMessage = error?.response?.data?.message || error?.message || "Unknown error";
            throw new Error(errorMessage);
        }
    }

    const putRequest = async (url, requestData) => {
        const token = sessionStorage.getItem('apayroucarayxczijiuhxvkdsp')
        try {
            const datetime = await doAnotherthing()
            const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
            const headers = {
                'cache-control': 'no-cache',
                Authorization: "Bearer " + token,
                abfmeyohryhgbvlrgp: tokenHandling.token,
                BvFGbVtImTvIuDR: "MnBrVCrXEChDaWgU"
            }

            const response = await axios.put(`${REST_API_SERVER}${url}`, requestData, { headers })
            if (response?.data?.status === 419) {
                toast.error(response?.data?.message)
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            } else if (response?.data?.statusCode === 419) {
                toast.error("Session expired!.")
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            }
            return response
        } catch (error) {
            throw new Error(error?.response?.data?.message)
        }
    }

    const deleteRequest = async url => {
        const token = sessionStorage.getItem('apayroucarayxczijiuhxvkdsp')
        try {
            const datetime = await doAnotherthing()
            const tokenHandling = getGen(`${REST_API_SERVER}${url}`, datetime.data)
            const headers = {
                'cache-control': 'no-cache',
                'content-type': 'application/json',
                Authorization: "Bearer " + token,
                abfmeyohryhgbvlrgp: tokenHandling.token,
                BvFGbVtImTvIuDR: "MnBrVCrXEChDaWgU"
            }
            const response = await axios.delete(`${REST_API_SERVER}${url}`, { headers })
            if (response?.data?.status === 419) {
                toast.error(response?.data?.message)
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            } else if (response?.data?.statusCode === 419) {
                toast.error("Session expired!.")
                sessionStorage.clear()
                sessionStorage.removeItem('permissions')
                sessionStorage.removeItem('role')
                window.location.href = '/'
            }
            return response
        } catch (error) {
            throw new Error(error?.response?.data?.message)
        }
    }


    return {
        getRequest,
        postRequest,
        putRequest,
        deleteRequest
    }
}

export default DataService